import React, { useEffect, useState } from 'react';
import { useAppSelector } from 'app/config/store';
import { useNavigate, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'edozvola-frontend-lib/dist/ui';
import { canUserSeeCaseQuery } from 'app/edozvola/cases/cases.queries';
import { SESSION_STORAGE_KEYS } from 'app/shared/util/local-storage-keys';
import axios from 'axios';
import { useKeycloak } from 'app/modules/keycloak/keycloak';
import { AUTHORITIES } from 'app/config/constants';
import '../cases/cases.scss'

export const CasesGuard = ({ children }) => {
  const { id: uuid } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const account = useAppSelector(state => state.authentication.account);
  const isAuthenticated = useAppSelector(state => state.authentication.isAuthenticated);
  const userAuthorities = useAppSelector(state => state.authentication.account.authorities);
  const hasAnonymousRole = userAuthorities && userAuthorities.includes(AUTHORITIES.NEPRIJAVLJENI);

  useEffect(() => {
    if (isAuthenticated && hasAnonymousRole && !sessionStorage.getItem(SESSION_STORAGE_KEYS.FROM_URL)) {
      sessionStorage.setItem(SESSION_STORAGE_KEYS.FROM_URL, location.pathname);
      redirectToNias();
    }
  }, []);

  const redirectToNias = () => {
    axios.get('api/keycloak-properties').then(response => {
      if (response.data.autoRedirectToNias === true) {
        useKeycloak()?.login({ idpHint: 'saml-nias' });
      } else {
        useKeycloak()?.login();
      }
    });
  };

  const { data: canUserSeeCase, isLoading } = canUserSeeCaseQuery(uuid, account);

  return (
    <>
      {!isLoading && canUserSeeCase === false && (
        <>
          <div className={'cases-guard-container'}>
            <FontAwesomeIcon icon={'user-shield'} className={'cases-guard-icon'} />
            <div className={'cases-guard-text'}>{'Nemate ovlaštenje vidjeti predmet!'}</div>
            <Button label={'Povratak'} size={'lg'} onClick={() => navigate('/my-cases', { replace: true })} />
          </div>
        </>
      )}
      {!isLoading && canUserSeeCase === true && children}
    </>
  );
};
